import {useGetSupportedScopeContextsQuery} from "../../../apis/Auth.api.ts";
import {ListSubheader, MenuList} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {CheckRounded, RadioButtonUncheckedRounded} from "@mui/icons-material";
import useAuth from "../../../hooks/useAuth.ts";
import {ScopeRoles} from "../../../types/auth";
import {styled} from "@mui/material/styles";
import { Trans } from "@lingui/react/macro";
import {useNavigate} from "react-router";
import Box from "@mui/material/Box";

const MenuTypography = styled(Typography)`
    padding-left: 0.2rem;
`;

const ScopeSwitcher = ({ onSelect }: { onSelect?: () => void }) => {

    const { session, handleRefresh, refreshLoading } = useAuth()
    const navigate = useNavigate();

    const {
        data: scopes,
        isLoading: isLoading,
        isFetching: isFetching,
    } = useGetSupportedScopeContextsQuery()

    const handleGroupChange = async (item: ScopeRoles) => {
        await handleRefresh(item.scopeGroupId)
        navigate('/dashboard')
        onSelect?.();
    };

    return (!isLoading || !isFetching || !refreshLoading) && session?.scopeGroupContext && scopes ? (
            <MenuList
                sx={{
                    maxHeight: 200,
                }}
            >
                <ListSubheader><Trans>Selected Group</Trans></ListSubheader>
                {scopes.map((item) => (
                    <MenuItem
                        key={item.scopeGroupId}
                        onClick={() => handleGroupChange(item)}
                        value={item.scopeGroupId}
                    >
                        { item.scopeGroupId === session.scopeGroupContext?.group ?
                            <CheckRounded />
                            :
                            <RadioButtonUncheckedRounded opacity={0}/>
                        }
                        {item.scopeGroupId ?
                            <Box sx={{ maxWidth: 400 }}>
                                <MenuTypography variant="subtitle1" fontSize="medium" noWrap>
                                    {item.rootScopeGroupName}
                                </MenuTypography>
                                <MenuTypography variant="subtitle2" fontSize="small" noWrap>
                                    {item.parentScopeGroupName}
                                </MenuTypography>
                                <MenuTypography variant="subtitle2" fontSize="small" noWrap>
                                    {item.scopeGroupContext}
                                </MenuTypography>
                            </Box>
                            :
                            <MenuTypography variant="body2" fontSize="small">
                                <Trans>Global</Trans>
                            </MenuTypography>
                        }
                    </MenuItem>
                ))}
            </MenuList>
        ) :
        (<></>)
}

export default ScopeSwitcher
